"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Mjolnir = undefined;

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _bluebird = require("bluebird");

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _MatrixClientPeg = require("../MatrixClientPeg");

var _MatrixClientPeg2 = _interopRequireDefault(_MatrixClientPeg);

var _BanList = require("./BanList");

var _SettingsStore = require("../settings/SettingsStore");

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _languageHandler = require("../languageHandler");

var _dispatcher = require("../dispatcher");

var _dispatcher2 = _interopRequireDefault(_dispatcher);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Move this and related files to the js-sdk or something once finalized.

var Mjolnir = exports.Mjolnir = function () {
    function Mjolnir() {
        var _this = this;

        (0, _classCallCheck3.default)(this, Mjolnir);
        this._lists = [];
        this._roomIds = [];
        this._mjolnirWatchRef = null;
        this._dispatcherRef = null;

        this._onAction = function (payload) {
            if (payload['action'] === 'setup_mjolnir') {
                console.log("Setting up Mjolnir: after sync");
                _this.setup();
            }
        };
    }

    (0, _createClass3.default)(Mjolnir, [{
        key: "start",
        value: function start() {
            this._mjolnirWatchRef = _SettingsStore2.default.watchSetting("mjolnirRooms", null, this._onListsChanged.bind(this));

            this._dispatcherRef = _dispatcher2.default.register(this._onAction);
            _dispatcher2.default.dispatch({
                action: 'do_after_sync_prepared',
                deferred_action: { action: 'setup_mjolnir' }
            });
        }
    }, {
        key: "setup",
        value: function setup() {
            if (!_MatrixClientPeg2.default.get()) return;
            this._updateLists(_SettingsStore2.default.getValue("mjolnirRooms"));
            _MatrixClientPeg2.default.get().on("RoomState.events", this._onEvent.bind(this));
        }
    }, {
        key: "stop",
        value: function stop() {
            _SettingsStore2.default.unwatchSetting(this._mjolnirWatchRef);

            try {
                if (this._dispatcherRef) _dispatcher2.default.unregister(this._dispatcherRef);
            } catch (e) {
                console.error(e);
                // Only the tests cause problems with this particular block of code. We should
                // never be here in production.
            }

            if (!_MatrixClientPeg2.default.get()) return;
            _MatrixClientPeg2.default.get().removeListener("RoomState.events", this._onEvent.bind(this));
        }
    }, {
        key: "getOrCreatePersonalList",
        value: function () {
            var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var personalRoomId, resp, list;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                personalRoomId = _SettingsStore2.default.getValue("mjolnirPersonalRoom");

                                if (personalRoomId) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 4;
                                return (0, _bluebird.resolve)(_MatrixClientPeg2.default.get().createRoom({
                                    name: (0, _languageHandler._t)("My Ban List"),
                                    topic: (0, _languageHandler._t)("This is your list of users/servers you have blocked - don't leave the room!"),
                                    preset: "private_chat"
                                }));

                            case 4:
                                resp = _context.sent;

                                personalRoomId = resp['room_id'];
                                _context.next = 8;
                                return (0, _bluebird.resolve)(_SettingsStore2.default.setValue("mjolnirPersonalRoom", null, _SettingsStore.SettingLevel.ACCOUNT, personalRoomId));

                            case 8:
                                _context.next = 10;
                                return (0, _bluebird.resolve)(_SettingsStore2.default.setValue("mjolnirRooms", null, _SettingsStore.SettingLevel.ACCOUNT, [personalRoomId].concat((0, _toConsumableArray3.default)(this._roomIds))));

                            case 10:
                                if (personalRoomId) {
                                    _context.next = 12;
                                    break;
                                }

                                throw new Error("Error finding a room ID to use");

                            case 12:
                                list = this._lists.find(function (b) {
                                    return b.roomId === personalRoomId;
                                });

                                if (!list) list = new _BanList.BanList(personalRoomId);
                                // we don't append the list to the tracked rooms because it should already be there.
                                // we're just trying to get the caller some utility access to the list

                                return _context.abrupt("return", list);

                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getOrCreatePersonalList() {
                return _ref.apply(this, arguments);
            }

            return getOrCreatePersonalList;
        }()

        // get without creating the list

    }, {
        key: "getPersonalList",
        value: function getPersonalList() {
            var personalRoomId = _SettingsStore2.default.getValue("mjolnirPersonalRoom");
            if (!personalRoomId) return null;

            var list = this._lists.find(function (b) {
                return b.roomId === personalRoomId;
            });
            if (!list) list = new _BanList.BanList(personalRoomId);
            // we don't append the list to the tracked rooms because it should already be there.
            // we're just trying to get the caller some utility access to the list

            return list;
        }
    }, {
        key: "subscribeToList",
        value: function () {
            var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(roomId) {
                var roomIds;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                roomIds = [].concat((0, _toConsumableArray3.default)(this._roomIds), [roomId]);
                                _context2.next = 3;
                                return (0, _bluebird.resolve)(_SettingsStore2.default.setValue("mjolnirRooms", null, _SettingsStore.SettingLevel.ACCOUNT, roomIds));

                            case 3:
                                this._lists.push(new _BanList.BanList(roomId));

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function subscribeToList(_x) {
                return _ref2.apply(this, arguments);
            }

            return subscribeToList;
        }()
    }, {
        key: "unsubscribeFromList",
        value: function () {
            var _ref3 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(roomId) {
                var roomIds;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                roomIds = this._roomIds.filter(function (r) {
                                    return r !== roomId;
                                });
                                _context3.next = 3;
                                return (0, _bluebird.resolve)(_SettingsStore2.default.setValue("mjolnirRooms", null, _SettingsStore.SettingLevel.ACCOUNT, roomIds));

                            case 3:
                                this._lists = this._lists.filter(function (b) {
                                    return b.roomId !== roomId;
                                });

                            case 4:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function unsubscribeFromList(_x2) {
                return _ref3.apply(this, arguments);
            }

            return unsubscribeFromList;
        }()
    }, {
        key: "_onEvent",
        value: function _onEvent(event) {
            if (!_MatrixClientPeg2.default.get()) return;
            if (!this._roomIds.includes(event.getRoomId())) return;
            if (!_BanList.ALL_RULE_TYPES.includes(event.getType())) return;

            this._updateLists(this._roomIds);
        }
    }, {
        key: "_onListsChanged",
        value: function _onListsChanged(settingName, roomId, atLevel, newValue) {
            // We know that ban lists are only recorded at one level so we don't need to re-eval them
            this._updateLists(newValue);
        }
    }, {
        key: "_updateLists",
        value: function _updateLists(listRoomIds) {
            if (!_MatrixClientPeg2.default.get()) return;

            console.log("Updating Mjolnir ban lists to: " + listRoomIds);
            this._lists = [];
            this._roomIds = listRoomIds || [];
            if (!listRoomIds) return;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(listRoomIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var roomId = _step.value;

                    // Creating the list updates it
                    this._lists.push(new _BanList.BanList(roomId));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: "isServerBanned",
        value: function isServerBanned(serverName) {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = (0, _getIterator3.default)(this._lists), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var list = _step2.value;
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {
                        for (var _iterator3 = (0, _getIterator3.default)(list.serverRules), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var rule = _step3.value;

                            if (rule.isMatch(serverName)) {
                                return true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            return false;
        }
    }, {
        key: "isUserBanned",
        value: function isUserBanned(userId) {
            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = (0, _getIterator3.default)(this._lists), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var list = _step4.value;
                    var _iteratorNormalCompletion5 = true;
                    var _didIteratorError5 = false;
                    var _iteratorError5 = undefined;

                    try {
                        for (var _iterator5 = (0, _getIterator3.default)(list.userRules), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                            var rule = _step5.value;

                            if (rule.isMatch(userId)) {
                                return true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                _iterator5.return();
                            }
                        } finally {
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return false;
        }
    }, {
        key: "roomIds",
        get: function get() {
            return this._roomIds;
        }
    }, {
        key: "lists",
        get: function get() {
            return this._lists;
        }
    }], [{
        key: "sharedInstance",
        value: function sharedInstance() {
            if (!Mjolnir._instance) {
                Mjolnir._instance = new Mjolnir();
            }
            return Mjolnir._instance;
        }
    }]);
    return Mjolnir;
}(); /*
     Copyright 2019 The Matrix.org Foundation C.I.C.
     
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
     
         http://www.apache.org/licenses/LICENSE-2.0
     
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
     */

Mjolnir._instance = null;
//# sourceMappingURL=Mjolnir.js.map